/* Auto-generated by scripts/fetch-geo-city-places.mjs — do not edit by hand */
import bucharest from './bucharest.json';
import type {GeoCityPlacesSnapshot} from '../../../types/geoApi';

export const GEO_CITY_PLACES_SNAPSHOTS: Record<string, GeoCityPlacesSnapshot> = {
    'bucharest': bucharest,
};
